import {AfterViewChecked, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import Utils from './core/utils/utils';
import {LanguageService} from './services/language.service';
import {LoaderService} from './services/loader.service';
import {Permissions} from './core/enums/permissions';
import {Menu} from './components/@theme/sidebar/interfaces/menu.interface';
import {MenuGroupEnum} from "./components/@theme/sidebar/enums/menu-group.enum";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewChecked {
    menus: Menu[];
    profileMenu: Menu[];

    constructor(
        public language: LanguageService,
        public loader: LoaderService,
        private changeRef: ChangeDetectorRef,
    ) {
        this.language.setLanguageCode(this.language.getLanguage().code);

        this.menus = [
            {
                description: 'title.deliveries',
                icon: 'far fa-paper-plane',
                link: '/deliveries',
                permissions: [Permissions.deliveries, Permissions.master],
                group: MenuGroupEnum.SMS
            },
            {
                description: 'title.configurations',
                icon: 'fas fa-sliders-h',
                link: '/configurations',
                permissions: [
                    Permissions.master, Permissions.deliveries, Permissions.groups, Permissions.campaigns,
                    Permissions.blacklist, Permissions.users, Permissions.price, Permissions.finance,
                    Permissions.reports, Permissions.apiStatus, Permissions.company
                ],
                group: MenuGroupEnum.SMS
            },
            {
                description: 'title.reports',
                icon: 'fas fa-chart-pie',
                link: '/reports',
                permissions: [Permissions.reports, Permissions.master],
                group: MenuGroupEnum.SMS
            },
            {
                description: 'title.api',
                icon: 'fas fa-plug',
                link: '/api',
                permissions: [
                    Permissions.master, Permissions.support, Permissions.reports, Permissions.deliveries,
                    Permissions.groups, Permissions.campaigns, Permissions.blacklist, Permissions.users,
                    Permissions.price, Permissions.finance, Permissions.reports, Permissions.apiStatus,
                    Permissions.company
                ],
                group: MenuGroupEnum.WHATSAPP
            }
        ];

        this.profileMenu = [
            { description: 'menu.changeProfile', link: '/profile' },
            { description: 'menu.exit', link: '/auth/signin' }
        ]
    }

    ngAfterViewChecked() {
        this.changeRef.detectChanges();
    }

    ngOnInit() {
        Utils.defaultVisualIdentity();
    }

}
